module.exports = __webpack_public_path__ + "static/media/api-error.25e4173e.png";